<modal-layout-right [modalTitle]="data.title">
    <div modalBody>
        <carousel class="default-swiper swiper-slide-per-view"
                  [slidesPerView]="'auto'"
                  [style.--pc-slides-ceil]="pcSlidesCeil"
                  [style.--pc-slides]="pcSlides"
                  [style.--pc-gutter]="pcGutter"
                  [freeMode]="true"
                  imageViewRoot
                  [gtmList]="{listId : 'ugc_modal', listName : 'UGC modal'}">
            @for(product of data.products; track product; let index = $index){
            <ng-template carouselSlide>
                <product [model]="product"
                         [gtmItem]="{ position: index + 1, product : product }"></product>
            </ng-template>
            }
        </carousel>
    </div>
</modal-layout-right>